export const CREATE_PICK_UP_LOCATION = "CREATE_PICK_UP_LOCATION";
export const UPDATE_PICK_UP_LOCATION = "UPDATE_PICK_UP_LOCATION";
export const DELETE_PICK_UP_LOCATION = "DELETE_PICK_UP_LOCATION";
export const FETCH_PICK_UP_LOCATIONS = "FETCH_PICK_UP_LOCATIONS";
export const LISTEN_TO_SELECTED_PICK_UP_LOCATION =
  "LISTEN_TO_SELECTED_PICK_UP_LOCATION";
